import { FilterObject, ExportType, mutations as TYPES, MyLibraryItemUpdate, Tag, TPeriod } from './types';
import { State } from './state';
import { FETCH, generateTagWithCount, getUseCaseInfo } from '@/utils/list';

const mutations = {
  /**
   * Reset
   * @param _state ..
   * @param state.show ..
   */
  [TYPES.RESET](_state: State) {
    _state = new State();
  },
  [TYPES.CHANGE_TAB](state: State, value: string) {
    state.activeTab = value;
  },
  [TYPES.CHANGE_LAYOUT](state: State, value: string) {
    state.layout = value;
  },
  [TYPES.TOGGLE](state: State, value: boolean) {
    state.active = value;
  },
  [TYPES.UPDATE_SHOW_ADD_TO_LIBRARY_ON_BOARDING](state: State, value: any) {
    state.showAddLibraryOnBoarding = value;
  },
  [TYPES.UPDATE_SHOW_SHARE_LIBRARY_ON_BOARDING](state: State, value: boolean) {
    console.log('vao', value);

    state.showShareLibraryOnBoarding = value;
  },
  //showShareLibraryOnBoarding
  [TYPES.COMMIT_BLOCK_DATA](state: State, data: any) {
    state.blocks = data;
  },
  [TYPES.COMMIT_ELEMENT_DATA](state: State, data: any) {
    // state.element.list = data;
    const comparer = (obj: any, item: any) => {
      return obj.id === item.id;
    };
    data?.snippets?.forEach((snippet: any) => {
      try {
        const metas = JSON.parse(snippet.metas);
        snippet.metas = metas;
        if (snippet.metas) {
          const bundle = JSON.parse(snippet.metas.bundle);
          snippet.metas.bundle = bundle;
        }
      } catch (error) {
        // Shhhhhhhhtt~~ Silence is golden
      }
    });
    FETCH(state.element.list, data?.snippets || [], comparer, null);
    state.element.categories = data.categories;
    state.element.tags = data.tags;
    state.fetchedTab.element = true;
  },
  [TYPES.MUTATE_ELEMENT_ITEM](state: State, { id, data }: { id: number; data: any }) {
    const idx = state.element.list.findIndex((x: any) => x.id == id);
    if (idx > -1) {
      const item = state.element.list[idx];
      Object.keys(data).forEach((key) => {
        item[key] = data[key];
      });
      state.element.list.splice(idx, 1, item);
    }
  },
  [TYPES.COMMIT_MYLIBRARY_DATA](state: State, data: any) {
    state.mylibrary.list = data.libraries;
    state.fetchedTab.mylibrary = true;
  },
  [TYPES.COMMIT_MYLIBRARY_SHARE_DATA](state: State, data: any) {
    state.mylibrary.shared = {
      fetched: true,
      limit: data.limit,
      stores: data.shared_domains,
    };
  },
  [TYPES.NUMBER_OF_USE_ADD_TO_PAGE](state: State, total: number) {
    state.numberUseAddToPage = total;
  },
  [TYPES.COMMIT_TEMPLATE_DATA](state: State, data: any) {
    state.template.recommendTemplates = JSON.parse(data.recommendTemplates.value);
    state.template.filter = data.filter;
    state.template.list = data.templates;
    state.fetchedTab.template = true;
  },
  [TYPES.COMMIT_TEMPLATE_TAG_DATA](state: State, data: any) {
    if (!state.fetchedTab.templateTags) {
      state.fetchedTab.templateTags = true;
      if (data.tags.usecaseConfig) {
        data.tags.usecaseConfig = JSON.parse(data.tags.usecaseConfig);
      }
      state.templateTags = data.tags;
    }

    if (!data.templates) {
      state.templateUseCase = data.tags?.template_usecase;
    } else {
      if (
        state.templateTags.usecaseConfig &&
        state.templateTags.usecaseConfig.templates &&
        state.templateTags.usecaseConfig.templates[data.pageType] &&
        state.templateTags.usecaseConfig.templates[data.pageType].length > 0
      ) {
        const templateUseCase: Tag[] = [];
        data.tags?.template_usecase.forEach((tag: Tag) => {
          const useCase = getUseCaseInfo(tag, data.pageType, data.templates);
          if (useCase) {
            templateUseCase.push(useCase);
          }
        });
        state.templateUseCase = templateUseCase;
      }
    }
  },
  [TYPES.COMMIT_BLOCK_TAG_DATA](state: State, data: any) {
    if (!state.fetchedTab.templateTags) {
      state.fetchedTab.templateTags = true;
      if (data.tags.usecaseConfig) {
        data.tags.usecaseConfig = JSON.parse(data.tags.usecaseConfig);
      }
      state.templateTags = data.tags;
    }
    state.blockUseCase = data.blockUseCase;
    // if (!data.blocks) {
    //   state.blockUseCase = data.tags?.block_usecase;
    // } else {
    //   const useCaseId = data.blocks.map((block: any) => [...block.use_cases]).flat() || ['EMPTY_USE_CASE'];
    //   const useCaseIdtr = `-${useCaseId.join('-').replaceAll('-', '--')}-`;
    //   state.blockUseCase = data.tags?.block_usecase
    //     ? data.tags.block_usecase.map((tag: any) => generateTagWithCount(tag, useCaseIdtr))
    //     : [];
    // }
  },
  [TYPES.COMMIT_DELETE_MYLIBRARY_ITEM](state: State, { id, type }: { id: number; type: string }) {
    const index = state.mylibrary.list.findIndex((x) => x.id == id && x.type == type);
    if (index > -1) {
      state.mylibrary.list.splice(index, 1);
      switch (type) {
        case 'block':
          state.mylibrary.allBlocks -= 1;
          state.mylibrary.allSaved -= 1;
          break;
        default:
          state.mylibrary.allTemplates -= 1;
          state.mylibrary.allSaved -= 1;
          break;
      }
    }
  },
  [TYPES.COMMIT_UPDATE_MYLIBRARY_ITEM](
    state: State,
    { id, type, fields }: { id: number; type: string; fields: MyLibraryItemUpdate },
  ) {
    const index = state.mylibrary.list.findIndex((x) => x.id == id && x.type == type);
    if (index > -1) {
      const item = {
        ...state.mylibrary.list[index],
        ...fields,
      };
      state.mylibrary.list.splice(index, 1, item);
    }
  },
  [TYPES.COMMIT_MYLIBRARY_LIB](state: State, { data, type, global }: { data: any; type: string; global: boolean }) {
    const item = {
      ...data[type],
      type,
    };

    // eslint-disable-next-line no-console
    console.log({ data, type, global, item });

    let source = state.mylibrary.list;

    if (global) {
      source = state.template.list;
      if (type == 'block') {
        source = state.blocks.data;
      }
    }

    const idx = source.findIndex((x: any) => x.id == item.id && x.type == type);
    if (idx > -1) {
      source.splice(idx, 1);
    }
    source.unshift(item);
    switch (type) {
      case 'block':
        state.mylibrary.allBlocks += 1;
        state.mylibrary.allSaved += 1;
        break;
      default:
        state.mylibrary.allTemplates += 1;
        state.mylibrary.allSaved += 1;
        break;
    }
    state.mylibrary.export = new ExportType();
  },
  [TYPES.OPEN_CREATE_LIB](state: State, { type, target }: { type: string; target: JQuery | undefined }) {
    // switch layout to export
    state.layout = 'exportLibrary';
    // switch to library tab
    state.activeTab = 'library';
    // open library modal
    state.active = true;
    state.mylibrary.export.type = type;
    state.mylibrary.export.target = target;
  },
  [TYPES.OPEN_ELEMENT_DETAIL](state: State, id: number | string | number) {
    state.element.elementID = id;
    // open library modal
    state.active = true;
    // switch to element tab
    state.activeTab = 'elements';
    // switch layout to preview element
    state.layout = 'previewElements';
  },
  [TYPES.MUTATE_ELEMENT_ID](state: State, id: number | string | number) {
    state.element.elementID = id;
  },
  [TYPES.CLEAR_QUERIED_ITEMS](state: State) {
    state.mylibrary.queriedList = [];
    state.mylibrary.fetchedAllQuery = false;
  },
  [TYPES.RESET_FETCHED_DATA](state: State) {
    state.mylibrary.fetchedAll = false;
    const cacheList = state.mylibrary.cachedSavedList;
    const currentList = state.mylibrary.list;
    const cacheListLength = cacheList.length;
    const currentListLength = currentList.length;

    const cacheId = [];
    for (let i = 0; i < cacheListLength; i++) {
      cacheId.push(cacheList[i]?.id);
    }

    const resetList = [];
    for (let i = 0; i < currentListLength; i++) {
      const isReset = !cacheId.includes(currentList[i]?.id);
      isReset && resetList.push(currentList[i]);
    }

    state.mylibrary.list = resetList;
  },
  [TYPES.SYNC_FILTER_DATA](
    state: State,
    data: {
      key: keyof FilterObject;
      filterObject: any;
    },
  ) {
    state.filterObject[data.key] = data.filterObject;
  },
  [TYPES.RESET_FILTER](state: State) {
    state.filterObject = {
      element: {},
      block: {},
      template: {},
      myLibrary: {},
    };
  },
  [TYPES.UPDATE_BLOCK_PERIOD](state: State, period: TPeriod) {
    state.blocks.period = period;
  },
  [TYPES.COMMIT_SAVED_LIBRARY_INFO](state: State, data: { block: number; template: number }) {
    state.mylibrary.allBlocks = data.block;
    state.mylibrary.allTemplates = data.template;
    state.mylibrary.allSaved = data.block + data.template;

    return state;
  },
};

export default mutations;
